import { render } from "./SeguridadDosFactores.vue?vue&type=template&id=92613260&scoped=true"
import script from "./SeguridadDosFactores.vue?vue&type=script&lang=js"
export * from "./SeguridadDosFactores.vue?vue&type=script&lang=js"

import "./SeguridadDosFactores.vue?vue&type=style&index=0&id=92613260&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92613260"]])

export default __exports__